import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Enumerable from 'linq';
import { Subscription } from 'rxjs';
import { AddSurveyResultModel, SurveyViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConferenceSurveyService } from 'src/app/_services/generatedServices';
import { NavigationService } from 'src/app/_services/navigation-service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { Model } from 'survey-core';
import { ComponentCollection, Question } from 'survey-core';

@Component({
  selector: 'bxl-view-survey',
  templateUrl: 'view-survey.component.html',
})
export class ViewSurveyComponent implements OnInit, OnDestroy {
  initialized = false;
  conferenceId: string;
  surveyId: string;
  surveyModel: Model;
  survey: SurveyViewModel;
  authSubscription: Subscription;
  embed: boolean;

  constructor(private surveyService: ConferenceSurveyService, private router:Router, private route: ActivatedRoute, private toaster: ToasterService, public auth: AuthenticationService, public navService: NavigationService) {}
  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      this.conferenceId = param.get('conferenceSlug');
      this.surveyId = param.get('surveyId');
      this.embed = this.router.url.indexOf('embed') > -1;

      this.surveyService.getSurveyBySlug(this.conferenceId, this.surveyId).subscribe((result) => {
        this.survey = result;
        const survey = new Model(JSON.parse(result.schemaJSON));
        survey.onComplete.add(this.surveyComplete.bind(this));
        this.surveyModel = survey;
        console.log(survey.getAllQuestions());
        this.updateQuestionsFromAuth();
        this.authSubscription = this.auth.loggedIn.subscribe(() => {
          this.updateQuestionsFromAuth();
        });
        this.initialized = true;
      });
    });
  }

  updateQuestionsFromAuth() {
    var questions = Enumerable.from(this.surveyModel.getAllQuestions());
    questions.forEach((question: Question) => {
      if (question.customQuestion?.name == 'bxlfirstname') {
        this.surveyModel.setValue(question.name, this.auth.user?.firstName);
      }

      if (question.customQuestion?.name == 'bxllastname') {
        this.surveyModel.setValue(question.name, this.auth.user?.lastName);
      }

      if (question.customQuestion?.name == 'bxlemail') {
        this.surveyModel.setValue(question.name, this.auth.user?.email);
      }

      console.log(question.customQuestion?.name);
    });



  }

  surveyComplete(sender) {
    var model = new AddSurveyResultModel();
    model.dataJSON = JSON.stringify(sender.data);

    this.surveyService.addSurveyResult(this.conferenceId, this.surveyId, model).subscribe((result) => {});
  }
}
